import { render, staticRenderFns } from "./mumsnetP2.vue?vue&type=template&id=9f27ee3e&scoped=true&"
import script from "./mumsnetP2.vue?vue&type=script&lang=js&"
export * from "./mumsnetP2.vue?vue&type=script&lang=js&"
import style0 from "./mumsnetP2.vue?vue&type=style&index=0&id=9f27ee3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f27ee3e",
  null
  
)

export default component.exports